__turbopack_context__.v({
  "ContactInfo": "ne5kcG_ContactInfo",
  "ContactInfoSubTitle": "ne5kcG_ContactInfoSubTitle",
  "ContactInfoTable": "ne5kcG_ContactInfoTable",
  "ContactInfoText": "ne5kcG_ContactInfoText",
  "ContactInfoTitle": "ne5kcG_ContactInfoTitle",
  "field": "ne5kcG_field",
  "flexedFields": "ne5kcG_flexedFields",
  "textarea": "ne5kcG_textarea",
  "title": "ne5kcG_title",
  "wrapper": "ne5kcG_wrapper",
});
